// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"a65344f1","68":"ba8156eb","69":"d91c2b21","340":"ca547af7","716":"9e8c187c","796":"2a2c8c2b"}[chunkId] + ".css";
};